import Box from "@mui/material/Box";
import CircularProgress from "@mui/material/CircularProgress";
import { memo } from "react";

export const Loading = memo(function Loading() {
  return (
    <Box sx={{ display: "flex", margin: "auto" }}>
      <CircularProgress sx={{ margin: "auto" }} />
    </Box>
  );
});
